import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const HospitalIcon = createIcon({
  displayName: 'HospitalIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M7,21v-15h-4c-0.552,0 -1,0.448 -1,1v14"></path>
        <path d="M22,21v-14c0,-0.552 -0.448,-1 -1,-1h-4v15"></path>
        <path d="M9.5,18h5"></path>
        <path d="M10.5,18h3v3h-3Z"></path>
        <path d="M10,15h4"></path>
        <path d="M10,12h4"></path>
        <path d="M5,13.5h2"></path>
        <path d="M5,17h2"></path>
        <path d="M5,10h2"></path>
        <path d="M23,21h-6"></path>
        <path d="M7,21h-6"></path>
        <path d="M17,13.5h2"></path>
        <path d="M17,17h2"></path>
        <path d="M17,10h2"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M7,21h10v-16.96c0,-0.574 -0.448,-1.04 -1,-1.04h-8c-0.552,0 -1,0.466 -1,1.04v16.96Z"></path>
        <path d="M10.5,7.5h3"></path>
        <path d="M12,9v-3"></path>
      </g>
    </>
  ),
})

const Hospital: FC<IconProps> = (props) => {
  return <CustomIcon as={HospitalIcon} {...props} />
}

export default memo(Hospital)
